module.exports = __webpack_public_path__ + "static/media/Deloitte_oc_Logo.77a7c520.svg";